import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var LogoutSvg = function LogoutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 2h13.314v5.37h-1.459V3.481H3.46v17.037h10.396V16.63h1.46V22H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.207 12.74-2.402 2.44 1.031 1.047L22 12l-4.164-4.227-1.031 1.047 2.402 2.44H8.2v1.48z"
  }));
};
export var Logout = function Logout(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: LogoutSvg
  }));
};